import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectStripe, CardElement } from 'react-stripe-elements';
import { saveStripeInfo } from '../helpers/auth';
import { saveUserToState } from '../reducers/user';
import { PrimaryButton } from './Button';

class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      loading: false,
      disabled: false
    };
  }

  handleChange = (e) => {
    this.setState({ name: e.target.value });
  };

  getStripeResponse = (email, sourceId) => {
    const payload = {
      email,
      sourceId
    };

    return fetch(`${process.env.REACT_APP_API_URI}/api/v1/stripe`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then((response) => response.json())
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({ loading: true, disabled: true });

    if (this.state.name === '') {
      console.error('Please enter your name');
      return;
    }

    // Within the context of `Elements`, this call to createToken knows which Element to
    // tokenize, since there's only one in this group.
    this.props.stripe
      .createSource()
      .then(({ source }) => {
        let email;
        if (this.props.email) {
          email = this.props.email;
        } else if (this.props.user.currentUser.info.email) {
          email = this.props.user.currentUser.info.email;
        } else {
          email = this.props.user.email;
        }

        return this.getStripeResponse(email, source.id);
      })
      .then((response) => {
        console.log('res', response);
        return saveStripeInfo(response);
      })
      .then((user) => {
        console.log(user);
        this.setState({ loading: false });
        this.props.saveUserToState(user);
        this.props.history.push('/dashboard');
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false, disabled: false });
      });
  };

  render() {
    const createOptions = (fontSize: string) => {
      return {
        base: {
          // fontSize,
          // color: '#424770',
          // letterSpacing: '0.025em',
          // fontFamily: "'Effra'",
          // '::placeholder': {
          //   color: '#aab7c4',
          // },
        },
        invalid: {
          color: '#9e2146'
        }
      };
    };

    return (
      <form onSubmit={this.handleSubmit} className="">
        <input
          type="text"
          value={this.state.name}
          onChange={this.handleChange}
          placeholder="Full Name"
          className="w-100 mb3 border-box input-reset ba b--black-20 pa3 db br2"
        />
        <CardElement className="ba b--black-20 pa3 db br2 mv2" style={createOptions(14)} />
        <PrimaryButton disabled={this.state.disabled} className="mt2">
          Confirm order
        </PrimaryButton>
      </form>
    );
  }
}

const Form = connect(
  (state) => ({
    user: state.user
  }),
  { saveUserToState }
)(withRouter(CheckoutForm));

export default injectStripe(Form);



// WEBPACK FOOTER //
// ./src/components/CheckoutForm.js